export default __webpack_public_path__ + "static/media/logo.449f2a8b.png";